module.exports = __webpack_public_path__ + "static/media/HeroImg.7f9b6bbb.svg";